import React, { useState, useRef, useEffect } from "react";

interface StatusOption {
  value: string;
  label: string;
  color: string;
}

interface StatusSelectProps {
  value: string;
  options: string[];
  colors: Record<string, string>;
  onChange: (value: string) => void;
}

export function StatusSelect({
  value,
  options,
  colors,
  onChange,
}: StatusSelectProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const items: StatusOption[] = options.map((op) => ({
    value: op,
    label: op === "" ? "" : op,
    color: colors[op] || "#ccc",
  }));

  const selected = items.find((i) => i.value === value);

  /** click outside */
  useEffect(() => {
    const close = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div ref={ref} className="relative w-full">
      {/* ▼ 表示部分（高さ/幅固定でテーブルが壊れない） */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between border rounded px-2 h-8 text-xs font-medium"
        style={{
          backgroundColor: selected?.color || "#f7f7f7",
          color: selected ? "#fff" : "#333",
        }}
      >
        <span className="truncate">{selected?.label || ""}</span>
        <span className="text-[10px] ml-2">▾</span>
      </button>

      {/* ▼ ドロップダウンメニュー */}
      {open && (
        <div className="absolute left-0 w-full mt-1 bg-white border rounded shadow-lg z-50 max-h-60 overflow-auto py-1">
          {items.map((item) => {
            const active = item.value === value;
            return (
              <div
                key={item.value}
                className="flex items-center px-2 py-1 text-xs cursor-pointer rounded"
                style={{
                  backgroundColor: active ? item.color : "#fff",
                  color: active ? "#fff" : "#333",
                }}
                onClick={() => {
                  onChange(item.value);
                  setOpen(false);
                }}
              >
                <span
                  className="inline-block w-2 h-2 rounded-full mr-2"
                  style={{ backgroundColor: item.color }}
                />
                {item.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
